import type {ComponentType} from 'react';
import {BASE_ADMIN_API, fetchAPI} from '@/services/api';

export interface Menu {
    menuId: number;
    pid: number;
    menuName: string;
    realm: string;
    realmUrl: string;
    realmModule: string;
    menuType: number;
    menuIcon: string;
    sort?: number;
    status: number;
    remarks: string;
    children: Menu[];
    /** Attached by router.attachComponent for page leaves */
    list?: ComponentType;
}

export interface RequestMenu {
    pid: number;
}

const defaultUrl = BASE_ADMIN_API + '/menu'

export async function getMenuById(menuId: number) {
    return fetchAPI<Menu>(`${defaultUrl}/getMenuById/${menuId}`, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
    });
}

// create menu
export async function createMenu(menu: Omit<Menu, 'menuId'>) {
    return fetchAPI<Menu>(`${defaultUrl}/createMenu`, {
        method: 'POST',
        body: JSON.stringify(menu),
        headers: {'Content-Type': 'application/json'},
    });
}

// update menu
export async function updateMenu(menuId: number, menu: Menu) {
    return fetchAPI<Menu>(`${defaultUrl}/updateMenu/${menuId}`, {
        method: 'POST',
        body: JSON.stringify(menu),
        headers: {'Content-Type': 'application/json'},
    });
}

// remove menu
export async function deleteMenu(menuId: number) {
    return fetchAPI<void>(`${defaultUrl}/deleteMenu/${menuId}`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
    });
}

export async function queryMenuTree(requestMenu: RequestMenu) {
    return fetchAPI<Menu[]>(`${defaultUrl}/queryMenuTree`, {
        method: 'POST',
        body: JSON.stringify(requestMenu),
        headers: {'Content-Type': 'application/json'},
    });
}

export async function queryMenuTreeByRoleId(roleId: []) {
    return fetchAPI<Menu[]>(`${defaultUrl}/queryMenuTreeByRoleId`, {
        method: 'POST',
        body: JSON.stringify({roleId}),
        headers: {'Content-Type': 'application/json'},
    });
}

export async function queryAllMenuMsg() {
    return fetchAPI<Menu[]>(`${defaultUrl}/queryAllMenuMsg`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
    });
}

export async function queryCurrentUserMenuTree(signal?: AbortSignal) {
    return fetchAPI<Menu[]>(`${defaultUrl}/queryCurrentUserMenuTree`, {
        method: 'GET',
        signal,
        headers: {'Content-Type': 'application/json'},
    });
}

export async function queryCurrentUserPermissions() {
    return fetchAPI<[]>(`${defaultUrl}/queryCurrentUserPermissions`, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
    });
}